exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrap_footer[data-v-775ed6ed] .el-pagination {\n  display: flex;\n  justify-content: center;\n}\n", ""]);

// exports
